<template>
  <div class="container">
    <div class="container__inner container__inner--min greeting">
      <p class="contentTitle">ごあいさつ</p>
      <p class="greeting__cont">私たち公立はこだて未来大学情報デザインコースは、情報科学や認知科学の最新の理論と実践を学びながら、人が情報社会で豊かに生きるためのデザイン理論や表現方法を取得し、人とテクノロジーの寄り添い方を学んでいます。</p>
      <p class="greeting__cont">本展のコンセプトは「新ふつうデザイン」です。
        <br>テレビが「ふつう」になったように、スマートフォンが「ふつう」になったように、時代の移り変わりとともに、私たちの生活に溶け込む「ふつう」もまた、変わり続けています。</p>
      <p class="greeting__cont">その中で、情報デザインを学ぶ私たちが卒業研究として取り組んできた、これからの新しい「ふつう」をご覧ください。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'o-exibitions'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$white: #fff;
$yellow: #eddb44;
$blue: #009898;

.greeting {
  &__cont {
    width: 100%;
    margin: 0 auto;
    line-height: 2;
    font-weight: 300;
    font-size: 18px;
    text-align: justify;
    letter-spacing: 4px;
    &:not(:first-child) {
      margin-top: 24px;
    }
  }
  @media screen and (max-width: 411px) {
    &__cont {
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/Greeting/index.vue